<template>
  <div class="bg-[#23242A] text-white app-header px-3 custom" id="content_screen">
    <div :class="'p-3 pt-0 flex content-main h-full d-scroll ' + (action.component ? ' half-it gap-5' : 'gap-5')">
      <div class="custom-full custom-left pb-[25px]">
        <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full">
          <div class="flex justify-between mb-5 h-[40px]">
            <h2 class="text-[24px] font-semibold text-white">Regular Categories</h2>
            <mdicon  @click="addUpdate({ component: 'Add', data: {}})" v-if="!action.component && can_edit_categories" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/>
          </div>
          <List :selectedCallback="selectedItem" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
        </div>
      </div>
  
      <div :class="'w-full hidden-component custom-right pb-[25px]'" v-if="action.component" >
        <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
      </div>

    </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import Nav from '@/views/Products/Category/Nav.vue';
import List from '@/views/Products/Category/RegularCategory/List.vue';
import Add from '@/views/Products/Category/RegularCategory/Add.vue';
import Update from '@/views/Products/Category/RegularCategory/Update.vue';
import Helpers from '@/helpers';

  export default defineComponent({
  name: "ProductCategories",
  components: {
    Nav,
    List,
    Add,
    Update,
  },

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });

    return {
      action,
    };
  },

   watch: {
    'vg_selectedLocation'(val) {
      // if location selected clear component
      this.clearComponent();
    },
  },

  computed: {

    /**
     * Edit restriction
     */
    can_edit_categories() {
      return Helpers.getMyPermission('can_edit_categories')
    },

    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  mounted() {
    this.emitter.on("reset-product-categories-component", data => {
      this.clearComponent();
    });
  },

  beforeDestroy() {
    this.emitter.off('reset-product-categories-component', () => {});
    this.emitter.off('refresh-product-categories-list', () => {});
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    
    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>